import React, { useEffect, useCallback, useState } from 'react'
import { Container, Box, Grid, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { usePrevious } from 'react-use'
import { parse } from 'query-string'
import { Layout } from '../../components'
import { InfoAction } from '../../store/info'
import { useReduxSelector } from '../../hooks'
import { img } from '../../imgs'
import {
  Materials,
  SamplesCheckList,
  Employees,
  Teams,
  Managers,
  TeamsReadOnly,
  CheckLists,
  TwoAccessStage,
  MySubdivisions,
  CheckListsTwoStage,
  ThreeAccessStage,
  TeamsThreeStage,
  MembersThreeStage,
} from './accordions'
import { Request } from './request'
import { RequestTwo } from './request-two'
import { CheckListPage } from './check-list'
import { getQuizTestMediaCup, getSubscribe, readSubscribe } from '../../api'
import { modalsAction } from '../../store/modals'
import { QuizTest } from './quiz-test'
import { ObjectInfoFirst, ObjectInfoFour, ObjectInfoThree, ObjectInfoTwo } from '../../types/default-types'

const emptyObject = (key_ob: string, object: any) => {
  const keys = Object.keys(object)
  let coincidence = false

  keys.forEach((key) => {
    if (key === key_ob) coincidence = true
  })

  return coincidence
}

export const LkPage: React.FC = (): JSX.Element => {
  const classes = useStyles()
  const navigate = useNavigate()

  const dispatch = useDispatch()

  const { pathname, search, hash } = useLocation()
  const prevLocation = usePrevious({ location: { pathname, search, hash } })

  const { REACT_APP_DEBUG: DEBUG } = process.env

  const {
    constants: { data: constData },
    auth: { data: userData },
    info: { data: infoData },
  } = useReduxSelector((state) => state)

  const [showCheckList, setShowCheckList] = useState<boolean>(false)
  const [mediaQuizTest, setMediaQuizTest] = useState<any>(undefined)

  const [employees, setEmployees] = useState<boolean>(false)
  const [teams, setTeams] = useState<boolean>(false)
  const [teamsReadOnly, setTeamsReadOnly] = useState<boolean>(false)
  const [managers, setManagers] = useState<boolean>(false)
  const [checkLists, setCheckLists] = useState<boolean>(false)
  const [accessStage, setAccessStage] = useState<boolean>(false)
  const [subdivision, setSubdivision] = useState<boolean>(false)
  const [membersThreeStage, setMembersThreeStage] = useState<boolean>(false)

  const loadInfoLK = useCallback(() => {
    dispatch(InfoAction({}))
  }, [])

  const loadMessageLk = useCallback(() => {
    getSubscribe().then((res) => {
      if (res.data.message) {
        dispatch(
          modalsAction.alert({
            message: { info: [res.data.message] },
            actionButtonText: '',
            onClose: () => {
              readSubscribe({ subscribeId: res.data.subscribeId }).then(() => loadMessageLk())
            },
          })
        )
      }
    })
  }, [])

  const loadMediaQuizTest = useCallback(() => {
    getQuizTestMediaCup().then((res) => {
      if (res.status === 1 && res.data.test) {
        setMediaQuizTest(res.data.test)
      } else setMediaQuizTest(undefined)
    })
  }, [])

  useEffect(() => {
    loadInfoLK()
    loadMessageLk()
    // loadMediaQuizTest()
  }, [])

  useEffect(() => {
    if (userData?.access && userData?.access.length > 0) {
      userData?.access.forEach((k, _) => {
        if (k.slug === '2_CHECKLIST_SAVE') {
          dispatch(
            modalsAction.alert({
              message: {
                info: [
                  `Обращаем внимание, если у Вас есть участники, не переведенные в третий этап. ` +
                    `Переведите или отклоните чек-лист сотрудника.`,
                ],
              },
              actionButtonText: '',
              onClose: () => {},
            })
          )
        }
      })
    }
  }, [userData])

  useEffect(() => {
    const query = parse(search)

    if (!prevLocation || prevLocation.location.search !== search) {
      switch (true) {
        case 'checklist' in query:
          setShowCheckList(true)
          break
        default:
          setShowCheckList(false)
          break
      }
    }
  }, [pathname, prevLocation, search])

  return (
    <Layout>
      <Box className={classes.page}>
        <Container className={classes.container}>
          {constData?.PROFILE === 'test' && !DEBUG && (
            <Grid container direction="row" alignItems="flex-start" justifyContent="center">
              <Grid item xs={12} md={10} lg={8}>
                <Box className={classes.titleTest}>Внимание!</Box>
                <Box className={classes.textTest}>
                  Вы тестируете чек-листы на тестовой площадке. Для оценки своих сотрудников и команд перейдите на{' '}
                  <a href="https://irbcup.ru/">сайт мероприятия «Кубок IRB»</a> и заполните все Чек&#8209;листы там.
                </Box>
              </Grid>
            </Grid>
          )}
          {infoData && showCheckList ? (
            <CheckListPage userData={userData} updateInfo={loadInfoLK} img={img} />
          ) : (
            <>
              <Grid container wrap="nowrap" justifyContent="space-between" alignItems="center" spacing={1}>
                <Grid item>
                  <Box className={classes.fullName}>
                    {userData?.lastName} {userData?.firstName} {userData?.middleName}
                  </Box>
                </Grid>
                <Grid item>
                  <Box className={classes.login}>ID:&nbsp;{userData?.externalId}</Box>
                </Grid>
              </Grid>
              <Box className={classes.position}>{userData?.position?.name}</Box>
              <Box className={classes.subdivision}>{userData?.subdivision?.name}</Box>

              <Box className={classes.dataBox}>
                <Materials className={classes} img={img} />

                <SamplesCheckList userData={userData} className={classes} img={img} />

                {/* подача заявки - сотрудник */}
                {infoData && emptyObject(ObjectInfoFirst.REQUEST_MY, infoData) && (
                  <Request data={infoData[ObjectInfoFirst.REQUEST_MY]} updateInfo={loadInfoLK} className={classes} />
                )}

                {/* {mediaQuizTest && <QuizTest quiz={mediaQuizTest} updateQuiz={loadMediaQuizTest} />} */}

                {/* Второй этап */}
                {/* {infoData && emptyObject('request_2', infoData) && infoData.request_2 && ( */}
                {/*  <RequestTwo data={infoData} className={classes} /> */}
                {/* )} */}

                {/* Первый этап */}
                {infoData &&
                  emptyObject(ObjectInfoFirst.SUBDIVISION, infoData) &&
                  infoData[ObjectInfoFirst.SUBDIVISION] && (
                    <MySubdivisions
                      img={img}
                      className={classes}
                      expanded={subdivision}
                      type="my_subdivision_dir"
                      data={infoData[ObjectInfoFirst.SUBDIVISION]}
                      onExpand={() => setSubdivision((prev) => !prev)}
                    />
                  )}

                {/* Второй этап */}
                {/* администратор */}
                {infoData &&
                  emptyObject(ObjectInfoTwo.SUBDIVISION_ADMIN, infoData) &&
                  infoData[ObjectInfoTwo.SUBDIVISION_ADMIN] && (
                    <MySubdivisions
                      img={img}
                      className={classes}
                      expanded={subdivision}
                      type="my_subdivision_admin"
                      data={infoData[ObjectInfoTwo.SUBDIVISION_ADMIN]}
                      onExpand={() => setSubdivision((prev) => !prev)}
                    />
                  )}

                {/* Второй этап */}
                {/* маркет-менеджер */}
                {infoData &&
                  emptyObject(ObjectInfoThree.SUBDIVISION, infoData) &&
                  infoData[ObjectInfoThree.SUBDIVISION] && (
                    <MySubdivisions
                      img={img}
                      className={classes}
                      expanded={subdivision}
                      type="my_subdivision_mm"
                      data={infoData[ObjectInfoThree.SUBDIVISION]}
                      onExpand={() => setSubdivision((prev) => !prev)}
                    />
                  )}

                {infoData &&
                  emptyObject(ObjectInfoFour.SUBDIVISION, infoData) &&
                  infoData[ObjectInfoFour.SUBDIVISION] && (
                    <MySubdivisions
                      img={img}
                      className={classes}
                      expanded={subdivision}
                      type="my_subdivision_mm"
                      data={infoData[ObjectInfoFour.SUBDIVISION]}
                      onExpand={() => setSubdivision((prev) => !prev)}
                    />
                  )}

                {/* Второй этап */}
                {/* HR-training */}
                {/* {infoData && */}
                {/*  emptyObject('my_subdivision_hr', infoData) && */}
                {/*  infoData.my_subdivision_hr && */}
                {/*  infoData?.my_subdivision_hr?.territorial?.length > 0 && ( */}
                {/*    <MySubdivisions */}
                {/*      type="my_subdivision_hr" */}
                {/*      data={infoData.my_subdivision_hr} */}
                {/*      className={classes} */}
                {/*      img={img} */}
                {/*    /> */}
                {/*  )} */}

                {/* Второй этап */}
                {/* Территориальный управляющий */}
                {infoData &&
                  emptyObject(ObjectInfoTwo.SUBDIVISION, infoData) &&
                  infoData[ObjectInfoTwo.SUBDIVISION] &&
                  infoData[ObjectInfoTwo.SUBDIVISION].length > 0 && (
                    <MySubdivisions
                      img={img}
                      className={classes}
                      expanded={subdivision}
                      type="my_subdivision_tt"
                      data={infoData[ObjectInfoTwo.SUBDIVISION]}
                      onExpand={() => setSubdivision((prev) => !prev)}
                    />
                  )}

                {/* Второй этап */}
                {/* Директор */}
                {/* {infoData && */}
                {/*  emptyObject('my_subdivision_dir', infoData) && */}
                {/*  infoData.my_subdivision_dir && */}
                {/*  infoData?.my_subdivision_dir?.users?.length > 0 && ( */}
                {/*    <MySubdivisions */}
                {/*      type="my_subdivision_dir" */}
                {/*      data={infoData.my_subdivision_dir} */}
                {/*      className={classes} */}
                {/*      img={img} */}
                {/*    /> */}
                {/*  )} */}

                {/* Второй этап */}
                {infoData &&
                  emptyObject(ObjectInfoTwo.CHECKLISTS, infoData) &&
                  infoData[ObjectInfoTwo.CHECKLISTS] &&
                  infoData[ObjectInfoTwo.CHECKLISTS].length > 0 && (
                    <CheckListsTwoStage
                      img={img}
                      stage={2}
                      className={classes}
                      expanded={checkLists}
                      data={infoData[ObjectInfoTwo.CHECKLISTS]}
                      openCheckList={() => navigate('../lk?checklist')}
                      onExpand={() => setCheckLists((prev) => !prev)}
                    />
                  )}

                {/* Третий этап */}
                {infoData &&
                  emptyObject(ObjectInfoThree.CHECKLISTS, infoData) &&
                  infoData[ObjectInfoThree.CHECKLISTS] &&
                  infoData[ObjectInfoThree.CHECKLISTS].length > 0 && (
                    <CheckListsTwoStage
                      img={img}
                      stage={3}
                      className={classes}
                      expanded={checkLists}
                      data={infoData[ObjectInfoThree.CHECKLISTS]}
                      openCheckList={() => navigate('../lk?checklist')}
                      onExpand={() => setCheckLists((prev) => !prev)}
                    />
                  )}

                {/* Финальный этап */}
                {infoData &&
                  emptyObject(ObjectInfoFour.CHECKLISTS, infoData) &&
                  infoData[ObjectInfoFour.CHECKLISTS] &&
                  infoData[ObjectInfoFour.CHECKLISTS].length > 0 && (
                    <CheckListsTwoStage
                      img={img}
                      stage={4}
                      className={classes}
                      expanded={checkLists}
                      data={infoData[ObjectInfoFour.CHECKLISTS]}
                      openCheckList={() => navigate('../lk?checklist')}
                      onExpand={() => setCheckLists((prev) => !prev)}
                    />
                  )}

                {/* Второй этап */}
                {infoData &&
                  emptyObject(ObjectInfoTwo.APPROVES, infoData) &&
                  infoData[ObjectInfoTwo.APPROVES] &&
                  infoData[ObjectInfoTwo.APPROVES].length > 0 && (
                    <ThreeAccessStage
                      img={img}
                      stage={2}
                      className={classes}
                      expanded={accessStage}
                      updateInfo={loadInfoLK}
                      data={infoData[ObjectInfoTwo.APPROVES]}
                      openCheckList={() => navigate('../lk?checklist')}
                      onExpand={() => setAccessStage((prev) => !prev)}
                    />
                  )}

                {/* Третий этап */}
                {infoData &&
                  emptyObject(ObjectInfoThree.APPROVES, infoData) &&
                  infoData[ObjectInfoThree.APPROVES] &&
                  infoData[ObjectInfoThree.APPROVES].length > 0 && (
                    <ThreeAccessStage
                      img={img}
                      stage={3}
                      className={classes}
                      expanded={accessStage}
                      updateInfo={loadInfoLK}
                      data={infoData[ObjectInfoThree.APPROVES]}
                      openCheckList={() => navigate('../lk?checklist')}
                      onExpand={() => setAccessStage((prev) => !prev)}
                    />
                  )}

                {/* Финальный этап */}
                {infoData &&
                  emptyObject(ObjectInfoFour.APPROVES, infoData) &&
                  infoData[ObjectInfoFour.APPROVES] &&
                  infoData[ObjectInfoFour.APPROVES].length > 0 && (
                    <ThreeAccessStage
                      img={img}
                      stage={4}
                      className={classes}
                      expanded={accessStage}
                      updateInfo={loadInfoLK}
                      data={infoData[ObjectInfoFour.APPROVES]}
                      openCheckList={() => navigate('../lk?checklist')}
                      onExpand={() => setAccessStage((prev) => !prev)}
                    />
                  )}

                {/* Второй этап */}
                {/* {infoData && */}
                {/*  emptyObject('create_command_2', infoData) && */}
                {/*  infoData.create_command_2 && */}
                {/*  infoData?.create_command_2?.length > 0 && ( */}
                {/*    <TeamsThreeStage data={infoData} updateInfo={loadInfoLK} className={classes} img={img} /> */}
                {/*  )} */}

                {/* /!* Второй этап *!/ */}
                {infoData &&
                  emptyObject(ObjectInfoTwo.WINNERS, infoData) &&
                  infoData[ObjectInfoTwo.WINNERS] &&
                  infoData[ObjectInfoTwo.WINNERS]?.length > 0 && (
                    <MembersThreeStage
                      img={img}
                      className={classes}
                      expanded={membersThreeStage}
                      data={infoData[ObjectInfoTwo.WINNERS]}
                      onExpand={() => setMembersThreeStage((prev) => !prev)}
                    />
                  )}

                {/* /!* Третий этап *!/ */}
                {infoData &&
                  emptyObject(ObjectInfoThree.WINNERS, infoData) &&
                  infoData[ObjectInfoThree.WINNERS] &&
                  infoData[ObjectInfoThree.WINNERS]?.length > 0 && (
                    <MembersThreeStage
                      img={img}
                      stage={3}
                      className={classes}
                      expanded={membersThreeStage}
                      data={infoData[ObjectInfoThree.WINNERS]}
                      onExpand={() => setMembersThreeStage((prev) => !prev)}
                    />
                  )}

                {/* /!* Четвертый этап *!/ */}
                {infoData &&
                  emptyObject(ObjectInfoFour.WINNERS, infoData) &&
                  infoData[ObjectInfoFour.WINNERS] &&
                  infoData[ObjectInfoFour.WINNERS]?.length > 0 && (
                    <MembersThreeStage
                      img={img}
                      stage={4}
                      className={classes}
                      expanded={membersThreeStage}
                      data={infoData[ObjectInfoFour.WINNERS]}
                      onExpand={() => setMembersThreeStage((prev) => !prev)}
                    />
                  )}

                {/* {infoData && */}
                {/*  emptyObject('user_requests', infoData) && */}
                {/*  infoData.user_requests && */}
                {/*  infoData?.user_requests?.length > 0 && ( */}
                {/*    <Employees data={infoData} updateInfo={loadInfoLK} className={classes} img={img} /> */}
                {/*  )} */}

                {/* список заявок - директор (менеджер - только просмотр) */}
                {infoData &&
                  emptyObject(ObjectInfoFirst.REQUEST_ALL, infoData) &&
                  infoData[ObjectInfoFirst.REQUEST_ALL] &&
                  infoData[ObjectInfoFirst.REQUEST_ALL]?.length > 0 && (
                    <Employees
                      img={img}
                      className={classes}
                      expanded={employees}
                      updateInfo={loadInfoLK}
                      full={userData?.role.id !== 2}
                      data={infoData[ObjectInfoFirst.REQUEST_ALL]}
                      onExpand={() => setEmployees((prev) => !prev)}
                    />
                  )}

                {/* создание команд - директор */}
                {infoData &&
                  emptyObject(ObjectInfoFirst.REQUEST_COMMAND, infoData) &&
                  infoData[ObjectInfoFirst.REQUEST_COMMAND] &&
                  infoData[ObjectInfoFirst.REQUEST_COMMAND].length > 0 && (
                    <Teams
                      img={img}
                      expanded={teams}
                      className={classes}
                      updateInfo={loadInfoLK}
                      data={infoData[ObjectInfoFirst.REQUEST_COMMAND]}
                      onExpand={() => setTeams((prev) => !prev)}
                    />
                  )}

                {/* список команд */}
                {infoData &&
                  emptyObject(ObjectInfoFirst.COMMAND_SHOW, infoData) &&
                  infoData[ObjectInfoFirst.COMMAND_SHOW] &&
                  infoData[ObjectInfoFirst.COMMAND_SHOW].length > 0 && (
                    <TeamsReadOnly
                      img={img}
                      className={classes}
                      expanded={teamsReadOnly}
                      data={infoData[ObjectInfoFirst.COMMAND_SHOW]}
                      onExpand={() => setTeamsReadOnly((prev) => !prev)}
                    />
                  )}

                {/* список менеджеров - директор */}
                {infoData &&
                  emptyObject(ObjectInfoFirst.MANAGERS, infoData) &&
                  infoData[ObjectInfoFirst.MANAGERS] &&
                  infoData[ObjectInfoFirst.MANAGERS].length > 0 && (
                    <Managers
                      img={img}
                      expanded={managers}
                      className={classes}
                      data={infoData[ObjectInfoFirst.MANAGERS]}
                      onExpand={() => setManagers((prev) => !prev)}
                    />
                  )}

                {/* список чек-листов - директор */}
                {infoData &&
                  emptyObject(ObjectInfoFirst.CHECKLISTS, infoData) &&
                  infoData[ObjectInfoFirst.CHECKLISTS] &&
                  infoData[ObjectInfoFirst.CHECKLISTS].length > 0 && (
                    <CheckLists
                      img={img}
                      className={classes}
                      expanded={checkLists}
                      data={infoData[ObjectInfoFirst.CHECKLISTS]}
                      openCheckList={() => navigate('../lk?checklist')}
                      onExpand={() => setCheckLists((prev) => !prev)}
                    />
                  )}

                {infoData &&
                  emptyObject(ObjectInfoFirst.APPROVES, infoData) &&
                  infoData[ObjectInfoFirst.APPROVES] &&
                  infoData[ObjectInfoFirst.APPROVES].length > 0 && (
                    <TwoAccessStage
                      img={img}
                      className={classes}
                      updateInfo={loadInfoLK}
                      expanded={accessStage}
                      data={infoData[ObjectInfoFirst.APPROVES]}
                      openCheckList={() => navigate('../lk?checklist')}
                      onExpand={() => setAccessStage((prev) => !prev)}
                    />
                  )}
              </Box>
            </>
          )}
        </Container>
      </Box>
    </Layout>
  )
}

const useStyles = makeStyles(({ font, breakpoints: { down }, palette }: Theme) => ({
  page: {
    width: '100%',
    height: '100%',
    backgroundColor: '#131313',
  },
  container: {
    maxWidth: '1000px!important',
    paddingTop: '70px!important',
    paddingBottom: '70px!important',
    [down('md')]: {
      paddingTop: '60px!important',
      paddingBottom: '60px!important',
    },
    [down('md')]: {
      paddingTop: '40px!important',
      paddingBottom: '40px!important',
    },
  },
  titleTest: {
    fontSize: 46,
    fontWeight: 700,
    textAlign: 'center',
    color: palette.error.main,
    textTransform: 'uppercase',
    marginBottom: 20,
    [down('lg')]: {
      fontSize: 42,
      marginBottom: 30,
    },
    [down('sm')]: {
      fontSize: 32,
      marginBottom: 20,
    },
  },
  textTest: {
    fontSize: 18,
    fontWeight: 500,
    textAlign: 'center',
    color: palette.secondary.main,
    textTransform: 'uppercase',
    marginBottom: 40,
    lineHeight: 1.4,
    '& a': {
      fontWeight: 700,
      whiteSpace: 'nowrap',
      color: palette.secondary.main,
    },
    [down('lg')]: {
      marginBottom: 30,
    },
    [down('sm')]: {
      fontSize: 14,
      marginBottom: 20,
    },
  },
  fullName: {
    fontSize: 24,
    [down('md')]: {
      fontSize: 22,
    },
  },
  login: {
    fontSize: 16,
    color: '#6C6C6C',
    [down('md')]: {
      fontSize: 15,
    },
  },
  position: {
    fontSize: 22,
    marginTop: 30,
    [down('md')]: {
      fontSize: 20,
      marginTop: 25,
    },
    [down('sm')]: {
      fontSize: 17,
      marginTop: 20,
    },
  },
  subdivision: {
    fontSize: 22,
    color: '#6C6C6C',
    marginTop: 10,
    [down('md')]: {
      fontSize: 20,
      marginTop: 10,
    },
    [down('sm')]: {
      fontSize: 17,
      marginTop: 5,
    },
  },
  email: {
    fontSize: 22,
    color: '#6C6C6C',
    marginTop: 10,
    [down('md')]: {
      fontSize: 20,
      marginTop: 10,
    },
    [down('sm')]: {
      fontSize: 17,
      marginTop: 5,
    },
  },
  dataBox: {
    marginTop: 35,
  },
  contentAccordionDetails: {
    borderTop: '2px solid #BABABA',
    padding: '20px 90px 0',
    [down('md')]: {
      padding: '20px 5.2vw 0',
    },
    [down('sm')]: {
      padding: '15px 0 0',
    },
  },
  subGroup: {
    '& .MuiAccordion-root': {
      boxShadow: 'none!important',
      marginBottom: '-5px!important',
      '& .Mui-expanded': {
        margin: '0px!important',
      },
    },
    '& .MuiAccordionSummary-root': {
      justifyContent: 'flex-start',
      paddingLeft: 0,
      paddingRight: 5,
    },
    '& .MuiAccordionSummary-content': {
      paddingRight: 15,
      fontSize: 18,
      fontWeight: 700,
      color: '#6C6C6C',
      margin: '0px!important',
      [down('md')]: {
        fontSize: 17,
      },
      [down('sm')]: {
        fontSize: 15.5,
      },
    },
    '& .MuiAccordionDetails-root': {
      paddingLeft: 0,
      paddingRight: 3,
      paddingBottom: 0,
    },
    [down('sm')]: {
      paddingLeft: 10,
    },
  },
  subGroupAccordionDetailsBox: {
    padding: '10px 15px 0 20px',
    marginTop: -10,
    borderTop: '2px solid #6C6C6C',
    [down('md')]: {
      padding: '20px 1vw 0 3.5vw',
    },
    [down('sm')]: {
      padding: '15px 0 0 10px',
    },
  },
  icon: {},
}))
